<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <label for="first-name">First name</label>
        <input
          class="form-control"
          type="text"
          name="first-name"
          v-model="$store.state.subscriberData['EmployeeFirstname' + employeeNr]"
        />
      </div>
      <div class="col-sm-6">
        <label for="last-name">Last name</label>
        <input
          class="form-control"
          type="text"
          name="last-name"
          v-model="$store.state.subscriberData['EmployeeLastname' + employeeNr]"
        />
      </div>
    </div>
    <label for="function">Function</label>
    <input
      class="form-control"
      type="text"
      name="function"
      v-model="$store.state.subscriberData['EmployeeFunction' + employeeNr]"
    />
    <label for="email">Email address</label>
    <input
      class="form-control"
      type="email"
      name="email"
      v-model="$store.state.subscriberData['EmployeeEmail' + employeeNr]"
      v-if="employeeNr == 1"
      disabled
    />
    <input
      class="form-control"
      type="email"
      name="email"
      v-model="$store.state.subscriberData['EmployeeEmail' + employeeNr]"
      v-else
    />
    <label for="phone">Phone number:</label>
    <input
      class="form-control"
      type="tel"
      name="phone"
      v-model="$store.state.subscriberData['EmployeePhone' + employeeNr]"
    />
  </div>
</template>

<script>
export default {
  name: "EmployeeForm",
  components: {},
  props: { employeeNr: String }
};
</script>